/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.35.0 of "Widgets"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { CreateContextualItemRequestBody } from '../models/CreateContextualItemRequestBody';
import type { CreateContextualItemResponseGenerated } from '../models/CreateContextualItemResponseGenerated';
import type { CreateWidgetRequestBody } from '../models/CreateWidgetRequestBody';
import type { CreateWidgetResponseGenerated } from '../models/CreateWidgetResponseGenerated';
import type { GetWidgetResponse } from '../models/GetWidgetResponse';
import type { GetWidgetsResponseGenerated } from '../models/GetWidgetsResponseGenerated';
import type { PatchWidgetRequestBody } from '../models/PatchWidgetRequestBody';
import type { UpdateWidgetPositionsBody } from '../models/UpdateWidgetPositionsBody';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class WidgetsService {

    /**
     * List all widgets
     * Retrieve all (or only the queried) widgets for the authorized user.
     * If the user has no Widgets stored prior to calling this endpoint a default set of widgets are returned.
     * This call uses the short timeouts for the Products endpoints.
     * If one of the backing calls to the Products endpoints fail, the call still succeeds and the affected widget is marked as having an error.
     * The list of Widgets are ordered to reflect in which order the consumer should show them.
     *
     * @returns GetWidgetsResponseGenerated The list of all Widgets configured for the user.
     * @throws ApiError
     */
    public static getPublicWidgets({
        georgeContextualBankingEmbedCalculations,
        type,
    }: {
        /**
         * Whether the calculations for the contextual banking widget should be embedded.
         * The service may override this and still return links instead of embedded data.
         *  Default: false
         */
        georgeContextualBankingEmbedCalculations?: boolean,
        /**
         * Retrieve only the widgets with the following types.
         */
        type?: Array<string>
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicWidgets({
        georgeContextualBankingEmbedCalculations,
        type,
    }: {
        /**
         * Whether the calculations for the contextual banking widget should be embedded.
         * The service may override this and still return links instead of embedded data.
         *  Default: false
         */
        georgeContextualBankingEmbedCalculations?: boolean,
        /**
         * Retrieve only the widgets with the following types.
         */
        type?: Array<string>
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetWidgetsResponseGenerated>;
    public static getPublicWidgets({
        georgeContextualBankingEmbedCalculations,
        type
    }: {
        /**
         * Whether the calculations for the contextual banking widget should be embedded.
         * The service may override this and still return links instead of embedded data.
         *
         */
        georgeContextualBankingEmbedCalculations?: boolean,
        /**
         * Retrieve only the widgets with the following types.
         */
        type?: Array<string>,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/widgets',
            query: {
                'type': type,
            },
            headers: {
                'GEORGE.CONTEXTUAL-BANKING-EMBED-CALCULATIONS': georgeContextualBankingEmbedCalculations,
            },
        });
    }

    /**
     * Create a widget
     * Create a (visible) widget of a given type with a mandatory name (does not have to be unique for a user) for the authorized user.
     * Currently, only creating a widget of type `MIXED_PRODUCTS` is supported.
     *
     * @returns CreateWidgetResponseGenerated Contains the id of the newly created widget.
     * @throws ApiError
     */
    public static postPublicWidgets({
        requestBody,
    }: {
        requestBody?: CreateWidgetRequestBody
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postPublicWidgets({
        requestBody,
    }: {
        requestBody?: CreateWidgetRequestBody
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<CreateWidgetResponseGenerated>;
    public static postPublicWidgets({
        requestBody
    }: {
        requestBody?: CreateWidgetRequestBody,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/widgets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `In case the widget could not be created.

                The \`type\` property of the \`Problem\` object can have the following values:
                 * \`error:generic/validation-failure\`: the title is longer than the \`maxLength\`
                 * \`error:dashboard/local-error/widget-limit-exceeded\`: the maximum number of widgets was reached.
                 * \`error:dashboard/local-error/product-per-widget-limit-exceeded\`: the maximum number of products per widget was exceeded.
                 * \`error:dashboard/local-error/contextual-items-bills-creation-not-supported\`: Bills contextual items cannot be created manually.
                `,
            },
        });
    }

    /**
     * Reset the widgets for the authorised user.
     * Irreversibly reset the widgets for the authorised user.
     *
     * @returns void
     * @throws ApiError
     */
    public static postPublicWidgetsReset(
        clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
        public static postPublicWidgetsReset(
            clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
            public static postPublicWidgetsReset(
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'POST',
                        url: '/public/widgets/reset',
                    });
                }

                /**
                 * Update the order of the widgets
                 * Update the order of all widgets associated with the authorized user.
                 * The new order is defined through the ordered array list of widget IDs passed inside the request body.
                 *
                 * Widget IDs not belonging to the user will be __ignored__, while missing widgets not provided in the request
                 * will be ordered __at the end__ of the provided list in their previous relative order to each other.
                 *
                 * Example:
                 *
                 * Consumer's widgets are in following order: [Widget1, Widget2, Widget3, Widget4]
                 *
                 * Consumer requests to update to the following order: [WidgetUnknown, Widget1, Widget4]
                 *
                 * Consumer's new widget order: [Widget1, Widget4, Widget2, Widget3]
                 *
                 * @returns void
                 * @throws ApiError
                 */
                public static putPublicWidgetsPositions({
                    requestBody,
                }: {
                    requestBody: UpdateWidgetPositionsBody
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static putPublicWidgetsPositions({
                    requestBody,
                }: {
                    requestBody: UpdateWidgetPositionsBody
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
                public static putPublicWidgetsPositions({
                    requestBody
                }: {
                    requestBody: UpdateWidgetPositionsBody,
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'PUT',
                        url: '/public/widgets/positions',
                        body: requestBody,
                        mediaType: 'application/json',
                    });
                }

                /**
                 * Get the contents of a widget
                 * Get the contents of the widget specified by the path parameter ID.
                 * This call uses the long timeouts for the Products endpoints.
                 * If upstream service fail and the widget type supports partial data/errors, then it will return a HTTP 200 response.
                 * If the widget type does not support partial data/errors, then it will return a 4/5xx response.
                 *
                 * @returns GetWidgetResponse A widget content
                 * @throws ApiError
                 */
                public static getPublicWidgetsById({
                    id,
                    georgeContextualBankingEmbedCalculations,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    /**
                     * Whether the calculations for the contextual banking widget should be embedded.
                     * The service may override this and still return links instead of embedded data.
                     *  Default: false
                     */
                    georgeContextualBankingEmbedCalculations?: boolean
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static getPublicWidgetsById({
                    id,
                    georgeContextualBankingEmbedCalculations,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    /**
                     * Whether the calculations for the contextual banking widget should be embedded.
                     * The service may override this and still return links instead of embedded data.
                     *  Default: false
                     */
                    georgeContextualBankingEmbedCalculations?: boolean
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<GetWidgetResponse>;
                public static getPublicWidgetsById({
                    id,
                    georgeContextualBankingEmbedCalculations
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    /**
                     * Whether the calculations for the contextual banking widget should be embedded.
                     * The service may override this and still return links instead of embedded data.
                     *
                     */
                    georgeContextualBankingEmbedCalculations?: boolean,
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'GET',
                        url: '/public/widgets/{id}',
                        path: {
                            'id': id,
                        },
                        headers: {
                            'GEORGE.CONTEXTUAL-BANKING-EMBED-CALCULATIONS': georgeContextualBankingEmbedCalculations,
                        },
                        errors: {
                            404: `Widget with ID not found for the authorized user.`,
                        },
                    });
                }

                /**
                 * Update (multiple) properties of a widget
                 * Use JSON Merge Patch to update a widget.
                 * Currently, this endpoint only supports the types: `MIXED_PRODUCTS`, `CONTEXTUAL_BANKING` and `ATTENTION` widgets.
                 *
                 * @returns void
                 * @throws ApiError
                 */
                public static patchPublicWidgets({
                    id,
                    requestBody,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    requestBody?: PatchWidgetRequestBody
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static patchPublicWidgets({
                    id,
                    requestBody,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    requestBody?: PatchWidgetRequestBody
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
                public static patchPublicWidgets({
                    id,
                    requestBody
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    requestBody?: PatchWidgetRequestBody,
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'PATCH',
                        url: '/public/widgets/{id}',
                        path: {
                            'id': id,
                        },
                        body: requestBody,
                        mediaType: 'application/json',
                        errors: {
                            400: `In case some problem occurred when patching the widget.

                            The \`type\` property of the \`Problem\` object can have the following values:
                             * \`error:generic/validation-failure\`: if the validation of the request body fails, e.g., title too long/patch operation not allowed/...
                             * \`error:dashboard/local-error/illegal-operation-for-widget-type\`: the widget type does not support setting the title (e.g., ATTENTION widget)
                             * \`error:dashboard/local-error/product-id-not-found\`: the product for a given reference id could not be found. \`detail\` contains more info (not localized).
                             * \`error:dashboard/local-error/unsupported-category\`: the product category for a given reference id is not supported. \`detail\` contains more info (not localized).
                             * \`error:dashboard/local-error/product-per-widget-limit-exceeded\`: the maximum number of products per widget was exceeded.
                             * \`error:dashboard/local-error/contextual-items-missing-calculation-id\`: The calculation contextual item with the given ID needs to be included for this operation.
                             * \`error:dashboard/local-error/contextual-items-unknown-id\`: The contextual item with the given ID was not found.
                             * \`error:dashboard/local-error/contextual-items-duplicated-calculation-id\`: Calculation id must be unique but the given calculation id is duplicated after modification.
                            `,
                            404: `Widget with the given id not found for the authorized user.`,
                        },
                    });
                }

                /**
                 * Delete a widget
                 * Irrevocably delete a widget.
                 * This only works for `MIXED_PRODUCTS` widgets, not `ATTENTION`/`CONTEXTUAL_BANKING` widgets.
                 *
                 * @returns void
                 * @throws ApiError
                 */
                public static deletePublicWidgets({
                    id,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static deletePublicWidgets({
                    id,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
                public static deletePublicWidgets({
                    id
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'DELETE',
                        url: '/public/widgets/{id}',
                        path: {
                            'id': id,
                        },
                        errors: {
                            404: `Widget with the given id not found for the authorized user.`,
                            405: `Widget cannot be deleted`,
                        },
                    });
                }

                /**
                 * Create a new contextual item for a `CONTEXTUAL_BANKING` widget.
                 * Create a contextual item and add it at the end of the contextual items for the widget.
                 * Currently, only creating a contextual item of type `CALCULATION` is supported.
                 *
                 * @returns CreateContextualItemResponseGenerated Contains the id of the newly created contextual item.
                 * @throws ApiError
                 */
                public static postPublicWidgetsItems({
                    id,
                    requestBody,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    requestBody?: CreateContextualItemRequestBody
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static postPublicWidgetsItems({
                    id,
                    requestBody,
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    requestBody?: CreateContextualItemRequestBody
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<CreateContextualItemResponseGenerated>;
                public static postPublicWidgetsItems({
                    id,
                    requestBody
                }: {
                    /**
                     * The `id` of the widget
                     */
                    id: string,
                    requestBody?: CreateContextualItemRequestBody,
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'POST',
                        url: '/public/widgets/{id}/items',
                        path: {
                            'id': id,
                        },
                        body: requestBody,
                        mediaType: 'application/json',
                        errors: {
                            400: `In case the contextual item could not be created.

                            The \`type\` property of the \`Problem\` object can have the following values:
                             * \`error:generic/validation-failure\`: the title is longer than the \`maxLength\`
                             * Potentially other types - TODO: extend this list when implementing
                            `,
                        },
                    });
                }

            }
